import { ThemeProvider } from '@mui/material';
import ApolloWithCognito from 'components/Apollo/ApolloWithCognito';
import Msal from 'components/Msal/Msal';
import Router from 'components/Router/Router';
import ThemeProviderExtended from 'components/ThemeProviderExtended/ThemeProviderExtended';
import useAuthWithCognito from 'hooks/useAuthWithCognito/useAuth';
import useMobileDetector from 'hooks/useMobileDetector';
import Welcome from 'pages/Welcome/Welcome';
import React from 'react';
import GlobalStyle from 'theme/GlobalStyle';
import { createMuiTheme } from 'theme/muiTheme';
import SnackbarProvider from 'ui/providers/SnackbarProvider';

const App: React.FC<React.PropsWithChildren> = () => {
  const { isUserAuthenticated, isLoading } = useAuthWithCognito();
  useMobileDetector();

  return <Router isLoading={isLoading} isUserAuthenticated={isUserAuthenticated} />;
};

const Bootstrap = () => {
  const theme = createMuiTheme('dark');

  return (
    <ThemeProviderExtended>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Msal LoadingScreen={Welcome}>
          <ApolloWithCognito>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </ApolloWithCognito>
        </Msal>
      </ThemeProvider>
    </ThemeProviderExtended>
  );
};

export default Bootstrap;
